import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import i18n from "../../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import getCorePersonalStore from "../../../../../../stores/core/core-personal-store";
import getKhattabat101CMessagingStore from "../../../../../../stores/khattabat-stores/101c-stores/101c-messaging-store";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const KhattabatReactivateKhattabaClient = withLiteObserverAndTheme<{
  conversationID: string;
  userID: number;
}>((props) => {
  const { conversationID, userID } = props;
  const conversationType =
    getKhattabatSharedMessagingStore(conversationID).conversationType.get();
  const isKhattabaAiAdmin = getCorePersonalStore().isKhattabaAiAdmin.get();

  if (conversationType !== "101C" || isKhattabaAiAdmin) {
    return null;
  }

  const {
    hasBeenReactivated,
    stringifiedReactivatedAt,
    shouldShowReactivationProcess
  } =
    getKhattabat101CMessagingStore(
      userID
    ).getKhattabaClientToReactivateDetails();

  if (!shouldShowReactivationProcess) {
    return null;
  }

  return hasBeenReactivated ? (
    <Typography variant="body2" textAlign="center">
      {stringifiedReactivatedAt}
    </Typography>
  ) : (
    <Button
      variant="contained"
      color="success"
      onClick={() =>
        getKhattabat101CMessagingStore(
          userID
        ).requestReactivatingKhattabaClient()
      }
    >
      {i18n.get("NOTICE_EMAIL")}
    </Button>
  );
});

export default KhattabatReactivateKhattabaClient;
